import { closeChat, isChatOpenSelector, openChat } from 'src/app/state/slices/chat';
import { useDispatch, useSelector } from 'src/app/state/store';
import { LOCALIZED_CONTACT_INFO, IS_MOBILE } from 'src/consts';

import { OTCBottomCardSection, OTCCardButton, OTCCardButtonSection, OTCChatTitle } from './styles';

export const OTCChatCard = () => {
  const dispatch = useDispatch();
  const dispatchOpenChat = () => dispatch(openChat());
  const dispatchCloseChat = () => dispatch(closeChat());
  const isChatOpen = useSelector(isChatOpenSelector);

  const handleClick = () => {
    const smsLocation = `sms:${LOCALIZED_CONTACT_INFO.CAPSULE_TEXT_NUMBER.DEFAULT}` as unknown as Location;

    if (IS_MOBILE) {
      //We set a timeout so the user can process they are on the logged in page before we switch them to the chat window
      setTimeout(() => {
        window.location = smsLocation;
      }, 1000);
    } else if (!isChatOpen) {
      dispatchOpenChat();
    } else if (isChatOpen) {
      dispatchCloseChat();
    }
  };

  return (
    <OTCBottomCardSection>
      <OTCChatTitle>Can’t find something? Let us know and we’ll try to get it for you.</OTCChatTitle>
      <OTCCardButtonSection>
        <OTCCardButton style="secondary" size="medium" onClick={handleClick} aria-label={`Chat With Us`}>
          Chat With Us
        </OTCCardButton>
      </OTCCardButtonSection>
    </OTCBottomCardSection>
  );
};
